module.exports = "/_next/static/images/d621d8838a9fd88e8d09140b3af01ca5-purple-check.svg.webp";